import React from 'react'

export const TaskPage = React.lazy(() => import('./task.page'))
